<div class="container">
  @if (registerResponse(); as response) {
    <mat-card appearance="outlined" data-cy="register-success-card">
      <h2>Verify Your Account</h2>
      <p style="margin: 0">
        <strong>A verification email was sent to your address.</strong>
      </p>
      <p>
        Please click the verification link in that email before attempting to
        sign in.
      </p>
      <button mat-flat-button color="primary" routerLink="/sign-in">
        Return to Sign In
      </button>
    </mat-card>
  } @else {
    @if (verifyInviteResponse(); as response) {
      @if (response.success) {
        <mat-card appearance="outlined">
          <h2>Create Password</h2>
          <form [formGroup]="passwordForm" (ngSubmit)="onPasswordFormSubmit()">
            <div class="password-requirements">
              <strong>Password requirements</strong>
              <app-custom-tooltip
                tooltipText="Passwords must be at least 10 characters, and must contain the following:
                    <ul style='padding-inline-start: 20px;'>
                    <li>At least one lowercase letter</li>
                    <li>At least one uppercase letter</li>
                    <li>At least one number</li>
                    <li>At least one non-alphanumeric character</li>
                  </ul>"
                position="right"
                backgroundColor="#517aa3"
                textColor="#fff"
                minWidth="250px"
              >
                <mat-icon
                  style="font-size: 22px; line-height: 24px; cursor: pointer"
                  >info</mat-icon
                >
              </app-custom-tooltip>
            </div>

            <mat-form-field hideRequiredMarker>
              <mat-label>Password</mat-label>
              <input
                [type]="hidePassword ? 'password' : 'text'"
                matInput
                [formControl]="passwordForm.controls.newPassword"
                data-cy="register-new-password-input"
              />
              <mat-icon
                matSuffix
                color="primary"
                (click)="hidePassword = !hidePassword"
                >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
              >
            </mat-form-field>

            <mat-form-field hideRequiredMarker>
              <mat-label>Confirm Password</mat-label>
              <input
                [type]="hidePassword ? 'password' : 'text'"
                matInput
                [formControl]="passwordForm.controls.confirmNewPassword"
                data-cy="register-confirm-password-input"
              />
              <mat-icon
                matSuffix
                color="primary"
                (click)="hidePassword = !hidePassword"
                >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
              >
            </mat-form-field>

            @if (
              passwordForm.controls.confirmNewPassword.invalid &&
              passwordForm.controls.confirmNewPassword.touched &&
              passwordForm.controls.confirmNewPassword.errors?.schemaFieldErrors
            ) {
              <p class="error">Passwords do not match.</p>
            }

            <button
              mat-flat-button
              color="primary"
              type="submit"
              [disabled]="!passwordForm.valid || spinner()"
              data-cy="register-submit-button"
            >
              @if (spinner()) {
                <mat-spinner
                  color="primary"
                  value="100"
                  mode="indeterminate"
                  style="margin-left: auto; margin-right: auto"
                  diameter="20"
                  strokeWidth="2"
                >
                </mat-spinner>
              } @else {
                Register
              }
            </button>
          </form>
        </mat-card>
      } @else {
        <mat-card appearance="outlined">
          <h2>Oh no!</h2>
          <p style="margin: 0">
            It looks like an error occurred while processing your invite. Please
            try the link again.<br /><br />If the issue persists, contact
            Customer Service at 866-783-5767.
          </p>
          <p style="margin-bottom: 0">
            Error Code: {{ response.body.actionCode }}
          </p>
        </mat-card>
      }
    } @else {
      <mat-spinner class="loading-spinner"></mat-spinner>
    }
  }
</div>
